import React from 'react';
import PropTypes from 'prop-types';
import PrintDetailedReport from '../PrintDetailedReport';
import PrintSummaryReport from '../PrintSummaryReport';
import {
  SUMMARY_PRINT_REPORT_VALUE,
  DETAILED_PRINT_REPORT_VALUE,
} from '../../reducers/report';
import { SUMMARY_REPORT_MODE_TYPE } from '../PrintSummaryReport';

const RouteSheetBody = ({
  data,
  addressMap,
  reportType = DETAILED_PRINT_REPORT_VALUE,
  mode,
}) => {
  if (reportType === SUMMARY_PRINT_REPORT_VALUE) {
    return (
      <PrintSummaryReport
        id={'print-report'}
        object={data}
        addressMap={addressMap}
        mode={mode}
      />
    );
  } else {
    return (
      <PrintDetailedReport
        id={'print-report'}
        object={data}
        addressMap={addressMap}
      />
    );
  }
};

RouteSheetBody.propTypes = {
  data: PropTypes.object,
  addressMap: PropTypes.object,
  reportType: PropTypes.oneOf([
    SUMMARY_PRINT_REPORT_VALUE,
    DETAILED_PRINT_REPORT_VALUE,
  ]),
  mode: SUMMARY_REPORT_MODE_TYPE,
};

export default RouteSheetBody;
